<div
  *ngIf="isOpen"
  class="fixed inset-0 z-[10000] overflow-y-auto"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="confirm-dialog-title">
  <div class="fixed inset-0 bg-slate-950/65" (click)="onBackdropClick()"></div>

  <div class="flex min-h-full items-end justify-center px-3 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] pt-[calc(1rem+env(safe-area-inset-top,0px))] sm:items-center sm:p-6">
    <div
      class="relative w-full max-w-md overflow-hidden rounded-lg border border-app-border bg-white text-left shadow-app-raised"
      [ngStyle]="{ 'font-size': fontSize + 'px' }"
      (click)="$event.stopPropagation()">
      <div class="max-h-[calc(100dvh-2rem)] overflow-y-auto">
        <div class="px-4 pb-4 pt-5 sm:px-6 sm:pb-5">
          <div class="flex items-start gap-3">
            <div class="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg" [ngClass]="getIconWrapClass()">
              <ng-container [ngSwitch]="type">
                <i *ngSwitchCase="'success'" class="bi bi-check-circle-fill app-icon text-xl" aria-hidden="true"></i>
                <i *ngSwitchCase="'danger'" class="bi bi-exclamation-octagon-fill app-icon text-xl" aria-hidden="true"></i>
                <i *ngSwitchCase="'warning'" class="bi bi-exclamation-triangle-fill app-icon text-xl" aria-hidden="true"></i>
                <i *ngSwitchCase="'info'" class="bi bi-info-circle-fill app-icon text-xl" aria-hidden="true"></i>
                <i *ngSwitchDefault class="bi bi-calendar-check app-icon text-xl" aria-hidden="true"></i>
              </ng-container>
            </div>

            <div class="min-w-0 flex-1">
              <div class="flex items-start justify-between gap-2">
                <h3 id="confirm-dialog-title" class="font-semibold leading-7 text-gray-900">
                  {{ title }}
                </h3>
                <button
                  *ngIf="showCloseButton"
                  type="button"
                  class="-mr-1 flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg text-slate-500"
                  [disabled]="cancelDisabled"
                  (click)="onCancel()"
                  aria-label="關閉">
                  <i class="bi bi-x-lg app-icon" aria-hidden="true"></i>
                </button>
              </div>
              <p *ngIf="message" class="mt-2 break-words leading-7 text-gray-600">
                {{ message }}
              </p>
            </div>
          </div>

          <div class="mt-4">
            <ng-content></ng-content>
          </div>
        </div>

        <div class="grid grid-cols-1 items-stretch gap-2 border-t border-app-highlight-line bg-app-highlight-soft px-4 py-3 min-[380px]:grid-cols-2 sm:px-6">
          <button
            type="button"
            class="inline-flex h-full min-h-12 w-full items-center justify-center whitespace-nowrap rounded-lg border border-slate-300 bg-white px-2 py-2.5 text-center font-semibold leading-6 text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 sm:px-4"
            [disabled]="cancelDisabled"
            [class.opacity-50]="cancelDisabled"
            [class.cursor-not-allowed]="cancelDisabled"
            (click)="onCancel()">
            {{ cancelText }}
          </button>
          <button
            type="button"
            class="inline-flex h-full min-h-12 w-full items-center justify-center whitespace-nowrap rounded-lg px-2 py-2.5 text-center font-semibold leading-6 text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:px-4"
            [ngClass]="getConfirmButtonClass()"
            [disabled]="confirmDisabled"
            [class.opacity-50]="confirmDisabled"
            [class.cursor-not-allowed]="confirmDisabled"
            (click)="onConfirm()">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
